import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SelectorComponent } from './selector/selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CreateComponent } from './create/create.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProfileComponent } from './profile/profile.component';
import { DescriptionListComponent } from './description-list/description-list.component';
import { MatTableModule } from '@angular/material/table';
import { AddAnotherDescriptionComponent } from './add-another-description/add-another-description.component';
import { CatalogueBrandSelectorComponent } from './catalogue-brand-selector/catalogue-brand-selector.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MultiSelectorComponent } from './multi-selector/multi-selector.component';
import { RatingQueueComponent } from './rating-queue/rating-queue.component';

@NgModule({
  declarations: [
    SelectorComponent,
    CreateComponent,
    ProfileComponent,
    DescriptionListComponent,
    AddAnotherDescriptionComponent,
    CatalogueBrandSelectorComponent,
    MultiSelectorComponent,
    RatingQueueComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatTableModule,
    MatCheckboxModule,
    MatAutocompleteModule
  ],
  exports: [
    SelectorComponent,
    CatalogueBrandSelectorComponent,
    MultiSelectorComponent,
    RatingQueueComponent
  ]
})
export class BrandModule {}
